import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature } from '@openfeature/react-sdk';

export const DESKTOP_RECORDER_START_TIMEOUT_FLAG_KEY =
  'config-desktop-recorder-start-timeout';

/**
 * Producer initialization inside Rust is independently bounded, while the
 * invoke also includes waits on recorder lifecycle locks. Sixty seconds leaves
 * headroom for slow hardware.
 */
export const DEFAULT_DESKTOP_RECORDER_START_TIMEOUT_MS = 60_000;

// Runtime configuration may add headroom for unusually slow hardware, but it
// must never shorten the compiled clinical-start budget.
export const MIN_DESKTOP_RECORDER_START_TIMEOUT_MS =
  DEFAULT_DESKTOP_RECORDER_START_TIMEOUT_MS;

export const parseDesktopRecorderStartTimeoutMs = (payload: unknown): number => {
  const timeoutMs = (payload as { timeoutMs?: unknown } | null)?.timeoutMs;
  return typeof timeoutMs === 'number' &&
    Number.isSafeInteger(timeoutMs) &&
    timeoutMs >= MIN_DESKTOP_RECORDER_START_TIMEOUT_MS
    ? timeoutMs
    : DEFAULT_DESKTOP_RECORDER_START_TIMEOUT_MS;
};

/**
 * Imperative getter shared by every native recorder-start entry point.
 *
 * This is a Flagsmith/OpenFeature config value rather than an analytics
 * payload. Until the config is provisioned, OpenFeature returns the empty
 * fallback and the compiled default remains in force.
 */
export const getDesktopRecorderStartTimeoutMs = (): number => {
  const payload = OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getObjectValue(
    DESKTOP_RECORDER_START_TIMEOUT_FLAG_KEY,
    {}
  );
  return parseDesktopRecorderStartTimeoutMs(payload);
};
